














import { Component, Mixins } from "vue-property-decorator";
import { ArrayUtilities } from "../../../../../utilities";
import { IBookmark } from "../../../../../domain/document";
import { ModelEditableMixin } from "../../../../system/mixins";

@Component
export default class BookmarkTool extends Mixins(ModelEditableMixin) {
  get bookmarks(): IBookmark[] {
    return this.readPropertyOrDefault(s => s.bookmarks, null);
  }

  hasName(column: IBookmark): boolean {
    return column.name && !!column.name.trim();
  }

  get displayItems(): IBookmark[][] {
    const maxRow = Math.max(...this.bookmarks.map(b => b.row));
    const maxColumn = Math.max(...this.bookmarks.map(b => b.column));
    const items = ArrayUtilities.createNew2dArray<IBookmark>(maxRow, maxColumn, this.createDummyBookmark());
    this.bookmarks.forEach(b => items[b.row - 1][b.column - 1] = b);
    return items;
  }

  createDummyBookmark(): IBookmark {
    // nameをブックマークのボタンに表示している。nameが空だとボタンの位置が少し上にずれるため全角スペースを指定している。
    return { itemSetId: null, item: null, name: "　", row: null, column: null, };
  }

  click(row: IBookmark) {
    if (row.itemSetId == null) { return; }
    this.editingSource.updateFocusedItem(row.itemSetId, row.item);
  }
}
